export function needsEsraRating(app = {}) {
  return app.esraNeedsRequest === true;
}
